import { useEffect, useState } from "react";
import "./CheckInOut.css";

export const RoomButton = ({ rooms, filteredRooms, setFilteredRooms }) => {
  const allCount = rooms.length;
  const availableCount = rooms.filter(
    (room) => room.hk_status === "clean",
  ).length;
  const dirtyCount = rooms.filter((room) => room.hk_status === "dirty").length;
  const inProgressCount = rooms.filter(
    (room) => room.hk_status === "in_progress",
  ).length;
  const outOfOrderCount = rooms.filter(
    (room) => room.hk_status === "out_of_order",
  ).length;

  const [activeButton, setActiveButton] = useState("all");

  const getButtonText = (type) => {
    switch (type) {
      case "all":
        return `All rooms (${allCount})`;
      case "clean":
        return `Clean (${availableCount})`;
      case "dirty":
        return `Dirty (${dirtyCount})`;
      case "in_progress":
        return `In Progress (${inProgressCount})`;
      case "out_of_order":
        return `Out of Order (${outOfOrderCount})`;
      default:
        return "";
    }
  };

  useEffect(() => {
    setFilteredRooms(rooms);
  }, [rooms, setFilteredRooms]);

  const handleRoomFilter = (filterType) => {
    let filtered;

    switch (filterType) {
      case "all":
        filtered = rooms;
        break;
      case "clean":
        filtered = rooms.filter((room) => room.hk_status === "clean");
        break;
      case "dirty":
        filtered = rooms.filter((room) => room.hk_status === "dirty");
        break;
      case "in_progress":
        filtered = rooms.filter((room) => room.hk_status === "in_progress");
        break;
      case "out_of_order":
        filtered = rooms.filter((room) => room.hk_status === "out_of_order");
        break;
      default:
        filtered = rooms;
    }

    setFilteredRooms(filtered);
    setActiveButton(filterType);
  };

  const buttonTypes = ["all", "clean", "dirty", "in_progress", "out_of_order"];

  return (
    <div className="button-container">
      {buttonTypes.map((type) => (
        <button
          key={type}
          onClick={() => handleRoomFilter(type)}
          className={`button ${activeButton === type ? "active" : ""}`}
        >
          {getButtonText(type)}
        </button>
      ))}
    </div>
  );
};

export default RoomButton;
